"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography = _interopRequireDefault(require("../../../../atoms/Typography/index.js"));
var _react = require("react");
require("./gauge.css");
var _gaugeProgress = _interopRequireDefault(require("./gaugeProgress.js"));
var _gaugeOverflow = _interopRequireDefault(require("./gaugeOverflow.js"));
var _gaugeBar = _interopRequireDefault(require("./gaugeBar.js"));
var _gaugeCard = _interopRequireDefault(require("./gaugeCard.js"));
var _gaugeLabels = _interopRequireDefault(require("./gaugeLabels.js"));
var _jsxRuntime = require("react/jsx-runtime");
const GaugeChart = props => {
  const {
    gaugeSize = 200,
    gaugeBarSize,
    gaugeBarColor,
    gaugeBarBaseColor,
    innerContentText = 'achieved',
    gaugeData = [{
      title: '',
      value: 0
    }],
    gaugeLabels = [0, 50, 100]
  } = props; //gaugeSize is width without 'px'. Height is auto adjusted
  const [percentage, setPercentage] = (0, _react.useState)(0);
  const [checkedItem, setCheckedItem] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (!checkedItem) {
      const data = gaugeData[0]?.value;
      if (data) {
        setCheckedItem(data);
        setPercentage(data);
      }
    }
  }, []);
  const handleChecked = (value, checkStatus) => {
    if (checkStatus) {
      setCheckedItem(value);
      setPercentage(value);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "gauge-component__container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "gauge-card__container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeCard.default, {
        checkedItem: checkedItem,
        gaugeData: gaugeData,
        handleChecked: handleChecked
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gaugeProgress.default, {
      gaugeSize: gaugeSize,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeLabels.default, {
        gaugeLabels: gaugeLabels,
        gaugeSize: gaugeSize
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeOverflow.default, {
        gaugeSize: gaugeSize,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeBar.default, {
          currentPercentage: percentage,
          gaugeSize: gaugeSize,
          gaugeBarSize: gaugeBarSize,
          gaugeBarBaseColor: gaugeBarBaseColor,
          gaugeBarColor: gaugeBarColor
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "gauge-inner__container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
          as: "h2",
          variant: "headline",
          children: [`${Math.floor(percentage)} %`, ' ']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          as: "p",
          variant: "caption-light",
          children: innerContentText
        })]
      })]
    })]
  });
  // return (
  // 	<div className="gauge-component__container">
  // 		<div className="gauge-card__container">
  // 			<GaugeCard checkedItem={checkedItem} gaugeData={gaugeData} handleChecked={handleChecked} />
  // 		</div>
  // 		<Typography variant="caption" className="gauge-bar__label" style={{ top: `${gaugeSize / 2.2}px` }}>
  // 			{gaugeStartLabel}
  // 		</Typography>
  // 		<Typography
  // 			variant="caption"
  // 			className="gauge-bar__label"
  // 			style={{ left: `${gaugeSize / 1.8}px`, top: '-15px' }}
  // 		>
  // 			{gaugeCenterLabel}
  // 		</Typography>
  // 		<GaugeProgress>
  // 			<GaugeOverflow gaugeSize={gaugeSize}>
  // 				<GaugeBar
  // 					currentPercentage={percentage}
  // 					gaugeSize={gaugeSize}
  // 					gaugeBarSize={gaugeBarSize}
  // 					gaugeBarBaseColor={gaugeBarBaseColor}
  // 					gaugeBarColor={gaugeBarColor}
  // 				/>
  // 			</GaugeOverflow>
  // 			<div className="gauge-inner__container">
  // 				<Typography as="h2" variant="headline">
  // 					{`${Math.floor(percentage)} %`}{' '}
  // 				</Typography>
  // 				<Typography as="p" variant="caption-light">
  // 					{innerContentText}
  // 				</Typography>
  // 			</div>
  // 		</GaugeProgress>
  // 		<Typography variant="caption" className="gauge-bar__label" style={{ top: `${gaugeSize / 2.2}px` }}>
  // 			{gaugeEndLabel}
  // 		</Typography>
  // 	</div>
  // );
};
var _default = exports.default = GaugeChart;
module.exports = exports.default;
module.exports.default = exports.default;